import api from "./apiConfig";

export const REGISTER_USER = async (userData) => {
	try {
		const response = await api.post("/register", userData);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const REGISTER_USER_RS = async (userData) => {
	try {
		const response = await api.post("/officeAssistants", userData);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ADMINS = async () => {
	try {
		const response = await api.get("/admin");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los administradores:", error);
		throw error;
	}
};

export const GET_LAWYERS = async () => {
	try {
		const response = await api.get("/lawyer");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los abogados:", error);
		throw error;
	}
};

export const GET_ACCOUNTANTS = async () => {
	try {
		const response = await api.get("/accountant");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los contadores:", error);
		throw error;
	}
};

export const GET_ACCOUNTANTS_BY_ADMIN_ID = async (id) => {
	try {
		const response = await api.get(`/accountantByAdmin/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener los contadores:", error);
		throw error;
	}
};

export const GET_USERS_RS = async () => {
	try {
		const response = await api.get("/officeAssistants");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los asistentes:", error);
		throw error;
	}
};

export const GET_CLIENT_CONTACT = async () => {
	try {
		const response = await api.get("/ClientContactDetails");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los contadores:", error);
		throw error;
	}
};

export const GET_ACCOUNTANT_BY_ID = async (id) => {
	try {
		const response = await api.get(`/accountant/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el contador:", error);
		throw error;
	}
};

export const GET_CLIENT_CONTACT_BY_USER = async (id) => {
	try {
		const response = await api.get(`/ClientContactDetailsByUser/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el cliente:", error);
		throw error;
	}
};

export const UPDATE_ADMIN = async (id, data) => {
	try {
		const response = await api.put(`/admin/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const UPDATE_ACCOUNTANT = async (id, data) => {
	try {
		const response = await api.put(`/accountant/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const UPDATE_LAWYER = async (id, data) => {
	try {
		const response = await api.put(`/lawyer/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const UPDATE_CLIENT = async (id, data) => {
	try {
		const response = await api.put(`/ClientContactDetails/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const UPDATE_USER = async (id, data) => {
	try {
		const response = await api.put(`/user/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const UPDATE_USER_RS = async (id, data) => {
	try {
		const response = await api.put(`/officeAssistants/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const DELETE_ADMIN = async (id) => {
	try {
		const response = await api.delete(`/admin/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_ACCOUNTANT = async (id) => {
	try {
		const response = await api.delete(`/accountant/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_CLIENT = async (id) => {
	try {
		const response = await api.delete(`/ClientContactDetails/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_USER = async (id) => {
	try {
		const response = await api.delete(`/user/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_USER_RS = async (id) => {
	try {
		const response = await api.delete(`/officeAssistants/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_LAWYER = async (id) => {
	try {
		const response = await api.delete(`/lawyer/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};
